var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _mask5, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 45 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 1.6094c0-0.6127 0.4971-1.1122 1.109-1.082 4.1206 0.20331 8.1139 1.5364 11.538 3.8634 3.4239 2.3269 6.1335 5.5491 7.8394 9.3054 0.2533 0.5579-0.0281 1.2039-0.5978 1.4295-0.5697 0.2255-1.2115-0.055-1.4679-0.6115-1.5401-3.3433-3.9648-6.2114-7.0209-8.2883-3.056-2.0769-6.6153-3.2755-10.291-3.4767-0.6118-0.03349-1.1089-0.52701-1.1089-1.1397z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 1.6094c0-0.6127 0.4971-1.1122 1.109-1.082 4.1206 0.20331 8.1139 1.5364 11.538 3.8634 3.4239 2.3269 6.1335 5.5491 7.8394 9.3054 0.2533 0.5579-0.0281 1.2039-0.5978 1.4295-0.5697 0.2255-1.2115-0.055-1.4679-0.6115-1.5401-3.3433-3.9648-6.2114-7.0209-8.2883-3.056-2.0769-6.6153-3.2755-10.291-3.4767-0.6118-0.03349-1.1089-0.52701-1.1089-1.1397z",
    mask: "url(#f)",
    stroke: "url(#g)",
    strokeWidth: 20
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.844 16.39c0.5827-0.1893 1.2114 0.1291 1.3718 0.7204 1.0799 3.9817 1.0461 8.1916-0.1089 12.167s-3.3821 7.5481-6.4275 10.331c-0.4523 0.4133-1.1537 0.3452-1.5442-0.1268-0.3906-0.4721-0.3221-1.1693 0.1279-1.585 2.7038-2.498 4.6823-5.6902 5.7131-9.2385 1.0309-3.5483 1.0709-7.3037 0.1265-10.862-0.1572-0.5922 0.1586-1.2174 0.7413-1.4068z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.844 16.39c0.5827-0.1893 1.2114 0.1291 1.3718 0.7204 1.0799 3.9817 1.0461 8.1916-0.1089 12.167s-3.3821 7.5481-6.4275 10.331c-0.4523 0.4133-1.1537 0.3452-1.5442-0.1268-0.3906-0.4721-0.3221-1.1693 0.1279-1.585 2.7038-2.498 4.6823-5.6902 5.7131-9.2385 1.0309-3.5483 1.0709-7.3037 0.1265-10.862-0.1572-0.5922 0.1586-1.2174 0.7413-1.4068z",
    mask: "url(#e)",
    stroke: "url(#a)",
    strokeOpacity: 0.4,
    strokeWidth: 20
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.158 40.244c0.3626 0.4939 0.2575 1.1908-0.2537 1.5285-3.4421 2.2744-7.4501 3.5627-11.587 3.713-4.1371 0.1502-8.228-0.8439-11.826-2.8626-0.5344-0.2998-0.6897-0.9872-0.364-1.5061 0.3258-0.5189 1.0092-0.6726 1.5452-0.3757 3.2199 1.7839 6.8716 2.6612 10.564 2.5271s7.271-1.2741 10.353-3.2868c0.513-0.335 1.2058-0.2313 1.5683 0.2626z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.158 40.244c0.3626 0.4939 0.2575 1.1908-0.2537 1.5285-3.4421 2.2744-7.4501 3.5627-11.587 3.713-4.1371 0.1502-8.228-0.8439-11.826-2.8626-0.5344-0.2998-0.6897-0.9872-0.364-1.5061 0.3258-0.5189 1.0092-0.6726 1.5452-0.3757 3.2199 1.7839 6.8716 2.6612 10.564 2.5271s7.271-1.2741 10.353-3.2868c0.513-0.335 1.2058-0.2313 1.5683 0.2626z",
    mask: "url(#d)",
    stroke: "url(#a)",
    strokeOpacity: 0.4,
    strokeWidth: 20
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.121 40.445c-0.35458 0.4997-1.049 0.6194-1.5306 0.2407-3.2428-2.5505-5.728-5.9486-7.1737-9.8278-1.4457-3.8792-1.7908-8.075-1.0081-12.126 0.11623-0.6015 0.71966-0.9655 1.3148-0.8198 0.59511 0.1458 0.95624 0.746 0.84325 1.3482-0.6788 3.6179-0.36122 7.3601 0.92917 10.822 1.2904 3.4624 3.4994 6.4996 6.3805 8.7908 0.47955 0.3814 0.59935 1.0716 0.24475 1.5712z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.121 40.445c-0.35458 0.4997-1.049 0.6194-1.5306 0.2407-3.2428-2.5505-5.728-5.9486-7.1737-9.8278-1.4457-3.8792-1.7908-8.075-1.0081-12.126 0.11623-0.6015 0.71966-0.9655 1.3148-0.8198 0.59511 0.1458 0.95624 0.746 0.84325 1.3482-0.6788 3.6179-0.36122 7.3601 0.92917 10.822 1.2904 3.4624 3.4994 6.4996 6.3805 8.7908 0.47955 0.3814 0.59935 1.0716 0.24475 1.5712z",
    mask: "url(#c)",
    stroke: "url(#a)",
    strokeOpacity: 0.4,
    strokeWidth: 20
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1575 16.386c-0.58267-0.1895-0.90406-0.8166-0.68614-1.3892 1.4674-3.8559 3.9698-7.2413 7.2414-9.7781 3.2715-2.5368 7.1735-4.1173 11.273-4.5782 0.6089-0.068452 1.1362 0.39899 1.1746 1.0105 0.0384 0.6115-0.4268 1.1352-1.0353 1.2069-3.6558 0.43098-7.133 1.8501-10.053 4.1142-2.92 2.2642-5.1603 5.2785-6.4881 8.7117-0.22101 0.5715-0.84404 0.8916-1.4267 0.7022z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m2.1575 16.386c-0.58267-0.1895-0.90406-0.8166-0.68614-1.3892 1.4674-3.8559 3.9698-7.2413 7.2414-9.7781 3.2715-2.5368 7.1735-4.1173 11.273-4.5782 0.6089-0.068452 1.1362 0.39899 1.1746 1.0105 0.0384 0.6115-0.4268 1.1352-1.0353 1.2069-3.6558 0.43098-7.133 1.8501-10.053 4.1142-2.92 2.2642-5.1603 5.2785-6.4881 8.7117-0.22101 0.5715-0.84404 0.8916-1.4267 0.7022z",
    mask: "url(#b)",
    stroke: "url(#a)",
    strokeOpacity: 0.4,
    strokeWidth: 20
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1.6048,
    x2: 43.716,
    y1: 17.441,
    y2: 17.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5936E4",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -18,
    x2: 68.243,
    y1: -27.427,
    y2: 7.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0,
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBg);
export default __webpack_public_path__ + "static/media/avatar-bg.8b34d6859af25eeaacaee093ea92eb48.svg";
export { ForwardRef as ReactComponent };